import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useLocalTime } from '@/hooks/use-local-time'

export const LocalDateTime: FC<{ date: string | Date | null; locale?: Locale }> = ({
  date,
  locale,
}) => {
  const { formatTime } = useLocalTime()

  return (
    <span>
      {formatTime({
        date,
        locale,
      })}
    </span>
  )
}
